import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchPreAdviceTransactionsHistory = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getPreAdviceTransactionHistory',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      transactionId: payload.params.transactionId,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchPreAdviceTransactionsHistory;
